import { Col } from "@commonlibs";
import IdentificationInput from "ui/common/components/input/IdentificationInput/IdentificationInput";
import TextField from "ui/common/components/input/TextField/TextField";
import useTranslate from "ui/locale/hooks/useTranslate";
import { IdentificationInputContainer, SpinnerWrapper, TextFieldRow } from "./CreateAdminForm.styles";
import { IdentificationInputValue, IdentificationType } from "ui/common/components/input/IdentificationInput/IdentificationInput.types";
import { CreateAdminFormProps } from "./CreateAdminForm.types";
import Spinner from "ui/common/components/feedback/SpinnerCircle/SpinnerCircle";

export default function CreateAdminForm({ onChange, onIdentificationInputBlur, form, isIdentificationLoading }: CreateAdminFormProps) {
    const translate = useTranslate();

    function onIdInputChange(value: IdentificationInputValue) {
        onChange("identificationType", value[0]!);
        onChange("identificationCode", value[1]);
    }

    function onBlurIdenficationInput(data: IdentificationInputValue | undefined) {
        if (data) {
            onIdentificationInputBlur(data);
        }
    }

    return (
        <Col gap={15}>
            <IdentificationInputContainer>
                <IdentificationInput
                    onChange={onIdInputChange}
                    value={[(form?.identificationType as IdentificationType) || "CC", form?.identificationCode || ""]}
                    placeholder="0000000000"
                    label={translate("identification")}
                    onBlur={onBlurIdenficationInput}
                />
                {isIdentificationLoading && (
                    <SpinnerWrapper>
                        <Spinner size={24} />
                    </SpinnerWrapper>
                )}
            </IdentificationInputContainer>
            <TextFieldRow style={{ display: "grid", width: "100%" }}>
                <TextField
                    readonly
                    value={form?.name}
                    onChange={(value) => onChange("name", value)}
                    placeholder={translate("name")}
                    label={translate("name")}
                />
                <TextField
                    readonly
                    value={form?.phone}
                    onChange={(value) => onChange("phone", value)}
                    placeholder="0000000000"
                    label={translate("phone")}
                    validators={{ number: true }}
                />
            </TextFieldRow>
            <TextField
                readonly
                value={form?.email}
                onChange={(value) => onChange("email", value)}
                placeholder={translate("emailPlaceholder")}
                label={translate("emailAdmin")}
                validators={{ email: true }}
            />
        </Col>
    );
}
